import { Navigate } from "react-router-dom";
import Navbar from "../../../components/Navbar/Navbar";
import { useDoesUserHavePermission } from "../../../hooks/permissions";
import { UserPermisions } from "../../../utils/types/user";
import NoteRuleBypassList from "../components/NoteRuleBypassList/NoteRuleBypassList";

export default function NoteRuleBypassPage() {
    const canViewNoteRuleBypass = useDoesUserHavePermission([
        UserPermisions.NOTE_RULE_BYPASS_READ,
    ]);

    if (!canViewNoteRuleBypass) {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <Navbar
                title="Note Rule Overrides"
                titleTooltip={
                    "An override applies to one provider and one client. " +
                    "The intake rule override allows another intake note within 12 months. " +
                    "The same day rule override allows another billable therapy note " +
                    "on a day when the client already has one."
                }
            />
            <div className="page">
                <NoteRuleBypassList />
            </div>
        </>
    );
}
